import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=1acf5cdc&scoped=true&lang=pug&"
import script from "./ShowList.vue?vue&type=script&lang=js&"
export * from "./ShowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf5cdc",
  null
  
)

export default component.exports